import gql from 'graphql-tag';

const GET_USEFUL_PHRASES = gql`
  query GetUsefulPhrases($lesson_id: Int!) {
    useful_phrases(lesson_id: $lesson_id) {
      category_id
      user_account
      description
      phrases {
        phrase_id
        phrase_en
        phrase_ja
      }
    }
  }
`;

const GET_USEFUL_PHRASES_MSB = gql`
  query GetUsefulPhrases($lesson_id: Int!) {
    usefulPhrases(lesson_id: $lesson_id) {
      category_id
      user_account
      description
      phrases {
        phrase_id
        phrase_en
        phrase_ja
      }
    }
  }
`;

export { GET_USEFUL_PHRASES, GET_USEFUL_PHRASES_MSB };
